<template>
  <div style="background: #1f1c1f;">
    <div class="header" >
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img_c" style="color: #e6b98a;">
          {{$t("q30")}}
        </div>
        <div></div>
        <div style="color:#e6b98a;font-size:14px;position: absolute;right: 20px;" @click="$router.push('/voteHistory')">{{$t("choose.vote_history")}}</div>
      </div>
    </div>
    <!-- 投票选手列表 -->
    <div class="vote_list">
      <van-notice-bar background="#f3c7a2" color="#8d5825" v-if="award_info" scrollable :text="award_info" />
      <div 
        class="vote_item" 
        v-for="(item) in datalist" 
        :key="item.id"
        @click="toDetail(item.id)"
      >
        <div class="vote_num">{{ item.noCode }}</div>

        <!-- 头像 -->
        <div class="vote_avatar">
          <img :src="$baseURL+'/'+item.img_url" />
        </div>
        <div class="vote_info">
          <div class="vote_name">{{ item.xuanfei_name }}</div>
          <div class="vote_item_info">{{$t("index.bust")}}：{{ item.bust }}</div>
          <div class="vote_item_info">{{$t("index.height")}}：{{ item.hight }}</div>
          <div class="vote_item_info">{{$t("index.address")}}：{{ item.address }}</div>
          <div class="vote_item_info" style="color:#efcba7;margin-top:8px;">{{$t("choose.vote_label")}}{{ item.dianzan || 0 }}</div>
        </div>

        <!-- 投票按钮 -->
        <div class="vote_btn">
          <span @click.stop="openVotePopup(item)">{{$t("foorter.video")}}</span>
        </div>
      </div>
    </div>
    <!-- ========== 投票弹窗 ========== -->
    <div class="vote_mask" v-if="showPopup" @click="closeVotePopup">
      <div class="vote_pop" @click.stop>
        <div class="pop_title">{{$t("choose.confirm_vote")}}</div>
        <div class="pop_avatar">
          <img :src="$baseURL+'/'+currentItem.img_url" />
        </div>
        <div class="pop_no">{{ currentItem.noCode }}</div>
        <div class="pop_name">{{ currentItem.xuanfei_name }}</div>
        <!-- 显示当前票数 -->
        <div style="color:#efcba7;font-size:26px;margin-bottom:20px;">{{$t("choose.current_votes")}}{{ currentItem.dianzan || 0 }}</div>
        <!-- 投票数量输入框 -->
        <div class="input_box">
          <input 
            v-model.number="voteNum" 
            type="number" 
            :placeholder="$t('choose.vote_count_placeholder')"
            min="1"
          />
        </div>
        <div class="pop_btn_box">
          <div class="pop_cancel" @click="closeVotePopup">{{$t("setting.cancel")}}</div>
          <div class="pop_confirm" @click="submitVote">{{$t("choose.confirm_vote")}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
        <div class="renzh">{{$t("q31")}}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <div class="c_c">{{$t("index.height")}}: {{item.hight}}cm</div>
          <div class="c_c">{{$t("index.bust")}}：{{ item.bust }}</div>
          <div class="c_c">{{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}</div>
          <div class="c_b_k">
            <img src="/img/neww/icon_views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/neww/icon_love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <img :src="$baseURL+'/'+item.img_url" class="sm_in_c van-image__img"
        style="object-fit: cover;">
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning'],
      showPopup: false,
      currentItem: {},
      voteNum: 1, // 投票数量 默认1
      award_info:""
    };
  },
  methods: {
    // 打开投票弹窗
    openVotePopup(item) {
      // 未登录跳转登录
      if (!this.hasToken) {
        this.toLogin('/Login');
        return;
      }
      this.currentItem = item;
      this.showPopup = true;
    },
    // 关闭弹窗
    closeVotePopup() {
      this.voteNum = 1;
      this.showPopup = false;
      this.currentItem = {};
    },
    // 提交投票（带数量）
    submitVote() {
      if (!this.voteNum || this.voteNum < 1) {
        this.$toast(this.$t("choose.vote_invalid_count"));
        return;
      }
      this.$http({
        method: "post",
        url: "doVote",
        data: {
          girl_id: this.currentItem.id,
          vote_num: this.voteNum
        }
      }).then(res => {
          if(res.code == 200){
            this.$toast(this.$t("choose.vote_success"));
            this.closeVotePopup();
            // 👇 投票后重新拉取列表，刷新票数
            this.getxuanfeilist();
          }else{
            this.$toast(this.$t(res.msg));
          }
      });
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
      console.log(res,11)
      });
    },
    getBanner(data){
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
    // 获取获奖信息
    getAwardDetail() {
      this.$http({
        method: "get",
        url: "getSystemContent",
        data: {
          type: 'award_info', 
        },
      }).then((res) => {
        this.award_info = res.data.content;
      });
    },
  },

  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
    this.getAwardDetail();
  },
};
</script>

<style lang="less" scoped>
/* ========== 投票弹窗样式 ========== */
.vote_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.vote_pop {
  width: 80%;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  .pop_title {
    font-size: 34px;
    color: #efcba7;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .pop_avatar {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #dcab76;
    margin: 0 auto 16px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .pop_no {
    font-size: 28px;
    color: #efcba7;
    margin-bottom: 8px;
  }
  .pop_name {
    font-size: 32px;
    color: #fff;
    margin-bottom: 30px;
  }
  /* 输入框样式 */
  .input_box {
    margin-bottom: 30px;
    input {
      width: 100%;
      height: 70px;
      border-radius: 12px;
      background: #2a2a2a;
      border: 1px solid #dcab76;
      color: #fff;
      font-size: 28px;
      text-align: center;
      outline: none;
    }
  }
  .pop_btn_box {
    display: flex;
    gap: 20px;
    .pop_cancel {
      flex: 1;
      padding: 14px;
      border-radius: 50px;
      background: #444;
      color: #ddd;
      font-size: 28px;
    }
    .pop_confirm {
      flex: 1;
      padding: 14px;
      border-radius: 50px;
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #8d5825;
      font-size: 28px;
      font-weight: bold;
    }
  }
}

/* 投票列表样式 */
.vote_list {
  padding-top: 120px;
  padding-bottom: 40px;
}
.vote_list .van-notice-bar{
  font-size: 32px !important;
  height: 50px;
}
.vote_item {
  margin: 20px 24px;
  padding: 24px;
  border-radius: 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  display: flex;
  align-items: center;
  position: relative;

  /* NO编号样式 */
  .vote_num {
    font-size: 28px;
    color: #efcba7;
    font-weight: bold;
    margin-right: 16px;
    white-space: nowrap;
  }

  /* 头像 */
  .vote_avatar {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #dcab76;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  /* 信息 */
  .vote_info {
    flex: 1;
    margin-left: 20px;

    .vote_name {
      font-size: 32px;
      color: #efcba7;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .vote_item_info {
      font-size: 26px;
      color: #ddd;
      margin-top: 6px;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 最多2行 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
      &.vote-num {
        color: #efcba7;
        font-weight: bold;
      }
    }
  }

  /* 投票按钮 */
  .vote_btn {
    padding: 12px 24px;
    border-radius: 50px;
    background: linear-gradient(90deg, #efcba7, #dcab76);
    color: #8d5825;
    font-size: 26px;
    font-weight: bold;
  }
}
.tu_list{
  padding-top: 100px;
  .tu_item{
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg,#212121,#313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh{
      position: absolute;
      right: -80px;
      top: 42px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c{
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box{
      .c_id{
        width: 200px;
        text-align: center;
        background-color: #fff;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c{
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k{
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in{
          width: 30px;
          height: 30px;
          &.cc{
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.nav_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    justify-content: space-between;
    padding-top: 10px;
    .top_link{
      padding: 20px 10px;
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
</style>
